// extracted by mini-css-extract-plugin
module.exports = {"Option":"RevisionSelect_Option__Gav_R","Date":"RevisionSelect_Date__xHPWX","Version":"RevisionSelect_Version__JZa9t"};